import type { BroadcastSeverity } from "@/features/admin/types";

/**
 * Broadcast severity → banner classes, using the app's semantic Tailwind tokens
 * (`destructive`/`warning`/`success` from `index.css`) rather than raw palette
 * colors, so it themes correctly in light/dark. Shared by the admin editor
 * preview and the firm-facing banner.
 */
export const SEVERITY_BANNER_CLASS: Record<BroadcastSeverity, string> = {
  danger: "bg-destructive/10 text-destructive border-destructive/30",
  warning: "bg-warning/10 text-warning border-warning/30",
  success: "bg-success/10 text-success border-success/30",
};
